var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-step"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:i,staticClass:"u-step-item",class:{active:_vm.active>=i}},[_c('div',{staticClass:"icon"},[_c('van-icon',{attrs:{"name":"checked"}})],1),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(step)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }